// extracted by mini-css-extract-plugin
export default {"badge":"badge__nhL3Z","base":"base__JVWX8 badge__nhL3Z","price":"price__F67Cl base__JVWX8 badge__nhL3Z"};